// TODO: remove
export const getSchoolUrl: () => string = () => '/school'
